import { useI18n } from 'vue-i18n'
export default class BasketballStatus {
  static ERROR = 0;
  static NOT_START = 1;
  static PART_1 = 2;
  static PART_1_END = 3;
  static PART_2 = 4;
  static PART_2_END = 5;
  static PART_3 = 6;
  static PART_3_END = 7;
  static PART_4 = 8;
  static ADD_TIME = 9;
  static FINISH = 10;
  static INTERRUPT = 11;
  static CANCELED = 12;
  static PUT_OFF = 13;
  static WAIST_CUT = 14;
  static DETERMINED = 15;
  static ROUNDS = ['第1节', '第2节', '第3节', '第4节', '加时'];

  static getStatus(status) {
    const { t } = useI18n()

    switch (status) {
      case BasketballStatus.ERROR:
        return t('match.matcherr');
      case BasketballStatus.NOT_START:
        return t('match.nomatch');
      case BasketballStatus.PART_1:
        return t('match.dyj');
      case BasketballStatus.PART_1_END:
        return t('match.dyjo');
      case BasketballStatus.PART_2:
        return t("match.dej");
      case BasketballStatus.PART_2_END:
        return t("match.dejo");
      case BasketballStatus.PART_3:
        return t("match.dsj");
      case BasketballStatus.PART_3_END:
        return t("match.dsjo");
      case BasketballStatus.PART_4:
        return t("match.dsjj");
      case BasketballStatus.ADD_TIME:
        return t("match.matchjs");
      case BasketballStatus.FINISH:
        return t("match.matchwc");
      case BasketballStatus.PUT_OFF:
        return t("match.matchtc");
      case BasketballStatus.INTERRUPT:
        return t("match.matchzd");
      case BasketballStatus.WAIST_CUT:
        return t("match.matchyz");
      case BasketballStatus.CANCELED:
        return t('tips.cancel');
      case BasketballStatus.DETERMINED:
        return t('match.matchdd');
    }
    return '';
  }

  static getType(type) {
    const { t } = useI18n()
    const STRARR = [
      '',
      t('match.matchsfqrqs'),
      t('match.matchefqrqs'),
      t('match.matchfqjqs'),
      t('match.matchsyzts'),
      t('match.matchfgs'),
      t('match.matchfqmzl'),
      t('match.matchzzts'),
    ];
    return STRARR[type] ? STRARR[type] : '';
  }
}
